export interface SEODefaults {
  title?: string;
  description?: string;
  image?: string;
  keywords?: string;
}